import { createFileRoute } from '@tanstack/react-router'
import { ErrorPage, LogoOnlyLayout } from 'merchant-components'

export const Route = createFileRoute('/(public)/apply')({
  component: LogoOnlyLayout,
  errorComponent: (props) => <ErrorPage {...props} />,
})
